import React from 'react';
import PropTypes from 'prop-types';
import Accordion from '../../DropDownForms/Accordion/Accordion';
import UniqueUrlForm from '../../DropDownForms/UniqueUrlForm/UniqueUrlForm';
import PasswordSettingsForm from '../../DropDownForms/PasswordSettingsForm/PasswordSettingsForm';
import ThemeDesignSettings from '../../DropDownForms/ThemeDesignSettings/ThemeDesignSettings';
import Panel from '../Panel/Panel';
import './WebsiteSettings.styles.less';


const WebsiteSettings = ({ themeGroupTitle, wedding, theme }) => {
  // used for mobile drop down
  const accordionItems = [
    {
      heading: 'Your Unique Url',
      body: UniqueUrlForm,
      icon: 'zolaicon-url-icon'
    },
    {
      heading: 'Website Settings',
      body: PasswordSettingsForm,
      icon: 'zolaicon-settings'
    }
  ];

  // used for desktop panel layout
  const panel = [
    {
      heading: 'Your Unique Url',
      body: UniqueUrlForm,
      icon: 'zolaicon-url-icon'
    },
    {
      heading: 'Website Settings',
      body: PasswordSettingsForm,
      icon: 'zolaicon-settings'
    },
    {
      heading: 'Design',
      body: ThemeDesignSettings,
      panelProps: { themeGroupTitle, wedding, theme },
      icon: 'zolaicon-website-design'
    }
  ];

  return (
    <React.Fragment>
      <div className="mpr-website-settings--mobile">
        <Accordion items={accordionItems} />
        <ThemeDesignSettings themeGroupTitle={themeGroupTitle} wedding={wedding} />
      </div>
      <div className="mpr-website-settings--desktop">
        <Panel items={panel} />
      </div>
    </React.Fragment>
  );
};

WebsiteSettings.propTypes = {
  themeGroupTitle: PropTypes.string,
  wedding: PropTypes.shape({}),
  theme: PropTypes.shape({})
};


export default WebsiteSettings;



// WEBPACK FOOTER //
// ./src/components/manage/website/ManagePagesRedesign/WebAdmin/WebsiteSettings/WebsiteSettings.jsx